<template>
    <div class="question-view-wrapper" @mouseover="mouseOnView" @mouseout="mouseOutView" :style="{ top: positionTop, left: positionLeft }">
        <div class="view-title">
            {{ title }}
            <span v-if="questionId" class="jump-to-newpage" @click="goQuestionEdit">{{ viewContent }}</span>
        </div>
        <div class="view-content">{{ content }}</div>
    </div>
</template>

<script>
export default {
    name: "QuestionSimpleView",
    props: ["content", "positionTop", "positionLeft", "questionId"],
    computed: {
        title() {
            return this.$t("zhiji.answer.answerDetail");
        },
        viewContent() {
            return this.$t("zhiji.answer.viewCompleteContent");
        }
    },
    methods: {
        mouseOnView() {
            this.$emit("onview");
        },
        mouseOutView() {
            this.$emit("outview");
        },
        goQuestionEdit () {
            const that = this;
            this.zhiji.goQuestionEdit(that, this.questionId);
        },
    }
};
</script>

<style lang="less" scoped>
.question-view-wrapper {
    margin-bottom: 16px;
    width: 277px;
    background: #fff;
    position: absolute;
    z-index: 1;
    top: 64px;
    left: 5px;
    border-radius: 4px;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

    .view-title {
        background: #e3edf6;
        padding: 8px;
        .jump-to-newpage {
            float: right;
            color: #2ec2ff;
            cursor: pointer;
        }
    }

    .view-content {
        box-sizing: border-box;
        padding: 8px;
        width: 100%;
        overflow: hidden;
        word-break: break-word;
    }
}
</style>
